import { getTokenInfo } from '@ibk/shared-auth';
import { baseApi, selectAccessToken } from '@ibk/shared-config';
export const paymentsApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getPaymentsV2: builder.query({
            query: ({ approvalState, status, pageSize, partyId, page = 1, globalSearch }) => {
                const params = {
                    approvalState,
                    status,
                    pageSize,
                    page,
                };
                if (globalSearch) {
                    params.globalSearch = globalSearch;
                }
                return {
                    url: '/v2/payments',
                    forceSelectedAccountInfoAccountId: true,
                    params: params,
                    headers: {
                        'party-id': partyId,
                    },
                    priority: 'high',
                };
            },
            providesTags: ['Base'],
        }),
        approvePaymentInstruction: builder.mutation({
            queryFn: async ({ instructionId, body }, api, _extraOptions, baseQuery) => {
                const state = api.getState();
                const token = selectAccessToken(state);
                if (!token) {
                    return {
                        error: {
                            status: 401,
                            data: { message: 'No access token available' },
                        },
                    };
                }
                const tokenInfo = getTokenInfo(token);
                const personId = tokenInfo?.personId ?? '';
                const result = await baseQuery({
                    url: `/v1/payments/instructions/${instructionId}/approve`,
                    method: 'POST',
                    body,
                    params: {
                        usePermissions: true,
                    },
                    headers: { 'person-id': personId },
                    forceSelectedAccountInfoAccountId: true,
                });
                if (result.error) {
                    return { error: result.error };
                }
                return { data: result.data };
            },
            invalidatesTags: ['Base'],
        }),
        reprovePaymentInstruction: builder.mutation({
            queryFn: async ({ instructionId }, api, _extraOptions, baseQuery) => {
                const state = api.getState();
                const token = selectAccessToken(state);
                if (!token) {
                    return {
                        error: {
                            status: 401,
                            data: { message: 'No access token available' },
                        },
                    };
                }
                const tokenInfo = getTokenInfo(token);
                const personId = tokenInfo?.personId ?? '';
                const result = await baseQuery({
                    url: `/v1/payments/instructions/${instructionId}/reprove`,
                    method: 'POST',
                    params: {
                        usePermissions: true,
                    },
                    headers: { 'person-id': personId },
                    forceSelectedAccountInfoAccountId: true,
                });
                if (result.error) {
                    return { error: result.error };
                }
                return { data: result.data };
            },
            invalidatesTags: ['Base'],
        }),
    }),
});
export const { useLazyGetPaymentsV2Query, useApprovePaymentInstructionMutation, useReprovePaymentInstructionMutation } = paymentsApi;
